import api from './api';

/**
 * SCAC Locations tablemaint support: the rpcylocations subtable feed for the SCAC Info
 * drawer, plus the shared Region option list (used by the SCAC Info / SCAC Locations Region
 * selects). The scaclocationmap records themselves use the generic /tablemaint engine.
 * (Distinct from scacinfo.service.ts, which serves the Pro Detail SCAC-info popover.)
 */
export interface ScacLocationMapRow {
  recno: number;
  scac: string;
  location: string;
  railportlocid: number;
  cylocid: number;
  other: string;
  rp_lname: string;
  cy_lname: string;
}

/** Non-deleted scaclocationmap rows for an exact (scac, location), with joined names —
 *  the SCAC Info drawer's embedded "Rail Port / CY Locations" list. */
export async function getScacLocationMap(scac: string, location: string): Promise<ScacLocationMapRow[]> {
  const res = await api.get('/scacinfo/location-map', { params: { scac, location } });
  return res.data as ScacLocationMapRow[];
}

/** CMS region list (REGION_OPTIONS) — shared by the SCAC Info / SCAC Locations Region
 *  selects. Cached for the session (small, static). */
let regionsCache: Promise<string[]> | null = null;
export async function getRegions(): Promise<string[]> {
  if (!regionsCache) {
    regionsCache = api.get<string[]>('/cms-lookups/regions').then((r) => r.data).catch((err) => {
      regionsCache = null;
      throw err;
    });
  }
  return regionsCache;
}
